import { SvgIcon } from "../../components/SvgIcon";
import { FontWeightEnum, Text, TextVariantsEnum } from "../../components/Text";
import { auth } from "../../config/firebase";
import { NAV_ITEM_NAME, TNavBarItem, navbarItem } from "./Navbar.utils";
import styles from "./Navbar.module.scss";
import classNames from "classnames";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useLoginSelector } from "../../store/login/useLoginSelectors";
import Avatar from "@mui/material/Avatar";

import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import { useLoginActions } from "../../store/login/useLoginActions";
import { actionClearUserDataById } from "../../store/login/login.reducer";
import { useDispatch } from "react-redux";

export const NavbarComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { logout } = useLoginActions();
  const [activeNav, setActiveNav] = useState(NAV_ITEM_NAME.OVERVIEW);
  const { userDataById } = useLoginSelector();
  const showAvatar = location.pathname !== "/login" && location.pathname !== "/";

  // useEffect(() => {
  //     if(userData.accountStatus === 'ACTIVE'){
  //         navigate(routes.login)
  //     }
  // },[])

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const handleActiveNav = (navData: TNavBarItem) => {
    setActiveNav(navData.name);
    navigate(navData.route);
  };

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
  handleCloseMenu();
  dispatch(actionClearUserDataById()); 
  await auth.signOut();       
  setActiveNav(NAV_ITEM_NAME.OVERVIEW);
  // navigate("/login");
};

  return (
    <div className={styles.navbarWrapper}>
      <img src={"./images/logo_white.svg"} width={135} />
      <div className={styles.headerLinks}>
        {navbarItem(activeNav).map((item, index) => (
          <div
            key={index}
            className={classNames(styles.item)}
            onClick={() => handleActiveNav(item)}
          >
            <SvgIcon
              className={classNames({ [styles.activeIcon]: item.active })}
              size={item.active ? 28 : 14}
              src={item.icon}
              // color={ item.active ? 'white' : 'neutral-30'}
              defaultStoke
            />
            <Text
              variant={TextVariantsEnum.Text_sm}
              fontWeight={FontWeightEnum.Normal}
              color={item.active ? "white" : "neutral-30"}
            >
              {item.name}
            </Text>
          </div>
        ))}
      </div>
      {showAvatar  && (
        <div>
          <IconButton onClick={handleAvatarClick}>
            <Avatar sx={{ width: 36, height: 36 }}>
              {userDataById.data.firstName?.[0] || "U"}
            </Avatar>
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={isMenuOpen}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem disabled>
              {userDataById.data.firstName || "User"}
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>
      )}
    </div>
  );
};
